import {RestResource} from "../rest";
import {ASSESSMENT_SERVER} from "../server";
import {athubAxios} from "../../util/athub-axios";

const addsubConf = new RestResource({server: ASSESSMENT_SERVER, resource: 'addsubConf'});

addsubConf.seq = (assessmentConf) => {
    let url = `${ASSESSMENT_SERVER}/addsubConf/seq`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, assessmentConf).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default addsubConf;